import { bicycleApiInstance } from './instance';
import { BICYCLE_API_ENDPOINTS } from './config';
import { 
  OwnerIdResponse, 
  OwnershipCheckResponse, 
  OwnerProductsResponse, 
  RegisterOwnerResponse,
  AdminOwnersResponse
} from '../types';

// Owner ID 발급 - 실제 test API 사용
export const getOwnerId = async (): Promise<OwnerIdResponse> => {
  try {
    const response = await bicycleApiInstance.get<OwnerIdResponse>(BICYCLE_API_ENDPOINTS.OWNER.GET_ID);
    return response.data;
  } catch (error) {
    console.error('Get Owner ID Error:', error);
    throw error;
  }
};

// 소유권 확인 - 실제 test API 사용
export const checkOwnershipAPI = async (urcode: string): Promise<OwnershipCheckResponse> => {
  try {
    const response = await bicycleApiInstance.get<OwnershipCheckResponse>(
      BICYCLE_API_ENDPOINTS.OWNER.CHECK_OWNERSHIP(urcode),
    );
    return response.data;
  } catch (error) {
    console.error('Check Ownership Error:', error);
    throw error;
  }
};

// 소유자 등록 - 실제 test API 사용
export const registerOwnerAPI = async (urcode: string, ownerId: string): Promise<RegisterOwnerResponse> => {
  try {
    const response = await bicycleApiInstance.post<RegisterOwnerResponse>(
      BICYCLE_API_ENDPOINTS.OWNER.REGISTER, 
      {
        ur: urcode,
        ownerId,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Register Owner Error:', error);
    throw error;
  }
};

// 소유 제품 목록 조회 - 실제 test API 사용
export const getOwnerProductsAPI = async (ownerId: string): Promise<OwnerProductsResponse> => {
  try {
    const response = await bicycleApiInstance.get<OwnerProductsResponse>(
      BICYCLE_API_ENDPOINTS.OWNER.GET_LIST(ownerId)
    );
    return response.data;
  } catch (error) {
    console.error('Get Owner Products Error:', error);
    throw error;
  }
};

// 개별 제품 삭제 - 실제 test API 사용
export const deleteOwnerProductAPI = async (ownerId: string, urcode: string): Promise<void> => {
  try {
    await bicycleApiInstance.get(
      BICYCLE_API_ENDPOINTS.OWNER.DELETE_ITEM(ownerId, urcode)
    );
  } catch (error) {
    console.error('Delete Owner Product Error:', error);
    throw error;
  }
};

// 전체 제품 삭제 (Clear All) - 실제 test API 사용
export const clearAllOwnerProductsAPI = async (ownerId: string): Promise<void> => {
  try {
    await bicycleApiInstance.get(
      BICYCLE_API_ENDPOINTS.OWNER.DELETE_ITEM(ownerId)
    );
  } catch (error) {
    console.error('Clear All Owner Products Error:', error);
    throw error;
  }
};

// 관리자 - 전체 Owner 목록 조회
export const getAllOwnersAPI = async (): Promise<AdminOwnersResponse> => {
  try {
    const response = await bicycleApiInstance.get<AdminOwnersResponse>(
      BICYCLE_API_ENDPOINTS.ADMIN.GET_ALL_OWNERS
    );
    return response.data;
  } catch (error) {
    console.error('Get All Owners Error:', error);
    throw error;
  }
};
